import { FC, useContext } from "react";
import { Modal } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { PlusOutlined } from "@ant-design/icons";
import DisabledContext from "antd/es/config-provider/DisabledContext";

import * as Styled from "./styles";
import { ImageUploadFieldProps } from "./types";
import { useImageUploadField } from "./hooks";

const ImageUploadField: FC<ImageUploadFieldProps> = (props) => {
  const disabledContextValue = useContext(DisabledContext);
  const { value, disabled } = props;
  const intl = useIntl();
  const {
    beforeUpload,
    fileList,
    onCancel,
    onPreview,
    onRemove,
    isPreviewModalOpened,
    url,
    title,
  } = useImageUploadField(props);
  const disabledValue =
    disabled !== undefined ? disabled : disabledContextValue;

  return (
    <DisabledContext.Provider value={disabledValue}>
      <Styled.Upload
        listType="picture-card"
        maxCount={1}
        {...{ fileList, onRemove, beforeUpload, onPreview }}
      >
        {!value && (
          <div>
            <PlusOutlined />
            <Styled.UploadLabelWrapper>
              <FormattedMessage defaultMessage="Upload" />
            </Styled.UploadLabelWrapper>
          </div>
        )}
      </Styled.Upload>
      <Modal open={isPreviewModalOpened} footer={null} {...{ onCancel, title }}>
        <Styled.PreviewImage
          alt={intl.formatMessage({ defaultMessage: "Event cover" })}
          src={url}
        />
      </Modal>
    </DisabledContext.Provider>
  );
};

export default ImageUploadField;
